// src/components/dashboard/trainer/TrainingQuickListCard.js
// Shared shape for the trainer dashboard's two action cards: a count plus
// a short inline list of the trainings behind it.
import React from 'react';
import { Table } from 'react-bootstrap';
import DashboardCard from '../DashboardCard';

function TrainingQuickListCard({ title, icon, count, items, loading, emptyMessage }) {
  return (
    <DashboardCard
      title={`${title} (${count})`}
      icon={icon}
      loading={loading}
      isEmpty={!loading && items.length === 0}
      emptyMessage={emptyMessage}
    >
      <Table borderless size="sm" className="mb-0 align-middle">
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              <td>
                <div className="fw-semibold">{item.title}</div>
                <div className="text-muted small">{item.code} &middot; {item.start_date} &middot; {item.location}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </DashboardCard>
  );
}

export default TrainingQuickListCard;
